<div class="proactive-feedback">
    <span class="close-button" (click)="close()">
        <img src="./assets/icons/icon_close.svg" alt="close-icon">
    </span>

    <!-- Initial asking ('yes'/ 'no') for 1363 -->
    <div *ngIf="isResponse">
        <div class="main">
            <div class="title">
                {{'FEEDBACK.TITLE' | translate}}
            </div>
            <div class="message">
                {{'FEEDBACK.MESSAGE' | translate}}
            </div>
        </div>

        <div class="buttons1">
            <button id="proactive-feedback-no-btn" class="secondary-button" (click)="feedbackSelected(false)"><img
                    src="./assets/icons/icon_sad.svg" alt="sad-icon">{{'FEEDBACK.BUTTONS.NO' | translate}}</button>
            <button id="proactive-feedback-yes-btn" class="secondary-button" (click)="feedbackSelected(true)"><img
                    src="./assets/icons/icon_happy.svg" alt="happy-icon">{{'FEEDBACK.BUTTONS.YES' | translate}}</button>
        </div>
    </div>

    <!-- Negative feedback(if selected 'NO') -->
    <div *ngIf="negativeFeed || positiveFeed" class="main">
        <div *ngIf="negativeFeed" class="message">
            <span>{{'FEEDBACK.MESSAGE1' | translate}}</span>
        </div>

        <div *ngIf="positiveFeed" class="message" style="margin-bottom: -10px;">
            <span>{{'FEEDBACK.MESSAGE2' | translate}}</span>
        </div>


        <div *ngIf="negativeFeed" class="buttons">

            <div *ngFor="let item of options; index as i" class="pointer">
                <div class="button" [ngClass]="{ 'bg-color': selected === item }">
                    <input type="radio" id={{item}} (change)="onItemChange(item)" name="example">
                    <label class="btn btn-default pointer" for={{item}}>{{item}}</label>
                </div>
            </div>
        </div>

        <div>
            <textarea name="" id="" placeholder="Share your thoughts (optional)" [(ngModel)]="feedback"></textarea>
        </div>

        <div class="feedback-footer">

             <div class="spinner"><mat-spinner *ngIf="isLoading" style="margin:0 auto;" [diameter]="35"></mat-spinner>
             </div>
            <button id="proactive-feedback-submit-btn" [class.hp-disabled-btn]="submitData" class="hp-primary-btn" (click)="submitFeedback()">{{'FEEDBACK.BUTTONS.SUBMIT' | translate}}</button>
        </div>
    </div>

</div>
